/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * Conference backend
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/Attachment', 'model/Lecturer', 'model/Question'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./Attachment'), require('./Lecturer'), require('./Question'));
  } else {
    // Browser globals (root is window)
    if (!root.ConferenceBackend) {
      root.ConferenceBackend = {};
    }
    root.ConferenceBackend.Presentation = factory(root.ConferenceBackend.ApiClient, root.ConferenceBackend.Attachment, root.ConferenceBackend.Lecturer, root.ConferenceBackend.Question);
  }
}(this, function(ApiClient, Attachment, Lecturer, Question) {
  'use strict';




  /**
   * The Presentation model module.
   * @module model/Presentation
   * @version 0.0.1
   */

  /**
   * Constructs a new <code>Presentation</code>.
   * @alias module:model/Presentation
   * @class
   */
  var exports = function() {
    var _this = this;













  };

  /**
   * Constructs a <code>Presentation</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Presentation} obj Optional instance to populate.
   * @return {module:model/Presentation} The populated <code>Presentation</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('_id')) {
        obj['_id'] = ApiClient.convertToType(data['_id'], 'String');
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (data.hasOwnProperty('image')) {
        obj['image'] = ApiClient.convertToType(data['image'], 'String');
      }
      if (data.hasOwnProperty('origin')) {
        obj['origin'] = ApiClient.convertToType(data['origin'], 'String');
      }
      if (data.hasOwnProperty('introduction')) {
        obj['introduction'] = ApiClient.convertToType(data['introduction'], 'String');
      }
      if (data.hasOwnProperty('fromDate')) {
        obj['fromDate'] = ApiClient.convertToType(data['fromDate'], 'Date');
      }
      if (data.hasOwnProperty('toDate')) {
        obj['toDate'] = ApiClient.convertToType(data['toDate'], 'Date');
      }
      if (data.hasOwnProperty('attachments')) {
        obj['attachments'] = ApiClient.convertToType(data['attachments'], [Attachment]);
      }
      if (data.hasOwnProperty('lecturers')) {
        obj['lecturers'] = ApiClient.convertToType(data['lecturers'], [Lecturer]);
      }
      if (data.hasOwnProperty('questions')) {
        obj['questions'] = ApiClient.convertToType(data['questions'], [Question]);
      }
      if (data.hasOwnProperty('updatedAt')) {
        obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
      }
      if (data.hasOwnProperty('createdAt')) {
        obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
      }
    }
    return obj;
  }

  /**
   * @member {String} _id
   */
  exports.prototype['_id'] = undefined;
  /**
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * @member {String} image
   */
  exports.prototype['image'] = undefined;
  /**
   * @member {String} origin
   */
  exports.prototype['origin'] = undefined;
  /**
   * @member {String} introduction
   */
  exports.prototype['introduction'] = undefined;
  /**
   * @member {Date} fromDate
   */
  exports.prototype['fromDate'] = undefined;
  /**
   * @member {Date} toDate
   */
  exports.prototype['toDate'] = undefined;
  /**
   * @member {Array.<module:model/Attachment>} attachments
   */
  exports.prototype['attachments'] = undefined;
  /**
   * @member {Array.<module:model/Lecturer>} lecturers
   */
  exports.prototype['lecturers'] = undefined;
  /**
   * @member {Array.<module:model/Question>} questions
   */
  exports.prototype['questions'] = undefined;
  /**
   * @member {Date} updatedAt
   */
  exports.prototype['updatedAt'] = undefined;
  /**
   * @member {Date} createdAt
   */
  exports.prototype['createdAt'] = undefined;



  return exports;
}));






// WEBPACK FOOTER //
// ./generated/src/model/Presentation.js